import { isEmpty } from '../../../helpers/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';
import Step from '@material-ui/core/Step';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import TextField from '@material-ui/core/TextField';
import alertUserStyles from '../styles';
import ImageSelectionAndCropper from "../../Organisms/ImageSelectionAndCropper";
import {compressImage} from "../../Organisms/ImageSelectionAndCropper/utils/base64Resize";

const useStyles = makeStyles(theme => ({
    actionsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    button: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    root: {
        width: '90%',
    },
}));

function getSteps() {
    return [
        'Enter your eventwide name',
        'Upload a profile picture (1024px x 1024px)',
        'Upload a background image for your event (2400px x 1000px)',
    ];
}

export default function VerticalLinearStepper({ activeEvent, alertUser, closeModal, setInitialSettings }) {
    const classes = useStyles();
    const alertUserClasses = alertUserStyles();
    const [state, setState] = useState({
        eventHeroImg: activeEvent.heroImage,
        name: alertUser.name,
        profileImg: alertUser.profileImage,
        profileImage120: alertUser.profileImageThumbnail,
    });
    const [activeStep, setActiveStep] = React.useState(0);
    const steps = getSteps();

    const handleSkip = () => {
        localStorage.setItem(`CC-${activeEvent.id}-onboarding`, 'skipped');
        closeModal();
    };

    const  handleSetProfile = async res => {
        const base64 = res;
        const base64_120 =  await compressImage(res, 120, 120)

        setState({ ...state, profileImg: base64, profileImage120: base64_120});
    };

    const handleSetEventImage = res => {
        setState({ ...state, eventHeroImg: res });
    };

    function handleNext() {
        switch (activeStep) {
            case 0:
                if (isEmpty(state.name)) {
                    return false;
                }
                break;
            case 1:
                if (isEmpty(state.profileImg)) {
                    return false;
                }
                break;
            case 2:
                if (isEmpty(state.eventHeroImg)) {
                    return false;
                }
                break;
            default:
        }
        setActiveStep(prevActiveStep => prevActiveStep + 1);

        if (activeStep === steps.length - 1) {
            const payload = {eventHero2400: state.eventHeroImg, name: state.name, profileImage120:state.profileImage120, profileImage1024:state.profileImg}
            setInitialSettings(payload);
        }
    }
    function checkCompleted(index) {
        switch (index) {
            case 0:
                return !isEmpty(state.name);
            case 1:
                return !isEmpty(state.profileImg);
            case 2:
                return !isEmpty(state.eventHeroImg);
            default:
                return false;
        }
    }
    function handleBack() {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    }

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} color="secondary" orientation="vertical">
                {steps.map((label, index) => (
                    <Step completed={checkCompleted(index)} key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            {activeStep === 0 && (
                                <FormControl className={classes.formControl} error={isEmpty(state.name)}>
                                    <span>Name to appear on moments, comment and notifications</span>
                                    <TextField
                                        className={alertUserClasses.textField}
                                        defaultValue=""
                                        id="onboarding-name"
                                        label="Name"
                                        margin="normal"
                                        onChange={evt => setState({ ...state, name: evt.target.value })}
                                        value={state.name}
                                    />
                                    <FormHelperText id="component-error-text">Enter your name</FormHelperText>
                                </FormControl>
                            )}
                            {activeStep === 1 && (
                                <Grid container>
                                    <Grid style={{ alignSelf: 'center' }} xs={6}>
                                        <FormControl
                                            className={classes.formControl}
                                            error={isEmpty(state.profileImg)}
                                        >
                                            <ImageSelectionAndCropper
                                                postSelectionButtonText={'Use Image'}
                                                aspectRatio={1}
                                                handleFileSelection={handleSetProfile}
                                                recommended={{width:1024, height:1024}}/>

                                            <FormHelperText className="component-error-text">
                                                You must upload a profile picture
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid>
                                        {state.profileImg && (
                                            <img
                                                alt={`Profile pic`}
                                                className={alertUserClasses.promptThumbnail}
                                                src={state.profileImg}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            )}{' '}
                            {activeStep === 2 && (
                                <Grid container>
                                    <Grid style={{ alignSelf: 'center' }} xs={6}>
                                        <span></span>
                                        <FormControl
                                            className={classes.formControl}
                                            error={isEmpty(state.eventHeroImg)}
                                        >
                                            <ImageSelectionAndCropper
                                                aspectRatio={2400/1000}
                                                handleFileSelection={handleSetEventImage}
                                                postSelectionButtonText={'Use Image'}
                                                recommended={{width:2400, height:1000}}/>

                                            <FormHelperText className="component-error-text">
                                                Enter a hero image for your event
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid>
                                        {state.eventHeroImg && (
                                            <img
                                                alt="Event hero"
                                                className={alertUserClasses.promptEventImage}
                                                src={state.eventHeroImg}
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            )}
                        </StepContent>
                    </Step>
                ))}
                <div className={classes.actionsContainer}>
                    <div>
                        <Button className={classes.button} disabled={activeStep === 0} onClick={handleBack}>
                            Back
                        </Button>
                        <Button
                            className={classes.button}
                            color="primary"
                            name="Onboarding-next"
                            onClick={handleNext}
                            variant="contained"
                        >
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                    </div>
                    <div>
                        <Button className={classes.button} onClick={handleSkip}>
                            Skip for now
                        </Button>
                    </div>
                </div>
            </Stepper>
        </div>
    );
}
